<template>
    <div></div>
</template>

<script>
    import loginJs from './login'
    export default loginJs
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue